import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M5.72235 12.5C5.32347 12.5 5.00012 12.1642 5.00012 11.75C5.00012 11.3703 5.27183 11.0565 5.62434 11.0068L5.72235 11L17.2779 11C17.6768 11 18.0001 11.3358 18.0001 11.75C18.0001 12.1297 17.7284 12.4435 17.3759 12.4932L17.2779 12.5L5.72235 12.5Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M17.0001 6.16667C17.0001 5.79848 17.3359 5.5 17.7501 5.5C18.1298 5.5 18.4436 5.7508 18.4933 6.0762L18.5001 6.16667L18.5001 16.8333C18.5001 17.2015 18.1643 17.5 17.7501 17.5C17.3704 17.5 17.0566 17.2492 17.007 16.9238L17.0001 16.8333L17.0001 6.16667Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M8.99022 16.937L8.99058 16.9368L8.98459 16.9275L8.94388 16.864L8.94422 16.8638L8.93762 16.855L5.17153 11.8335C5.16841 11.8294 5.16712 11.8242 5.16774 11.8192L5.17741 11.8021L8.93762 6.78842C9.15597 6.49728 9.09696 6.08426 8.80583 5.86591C8.54105 5.66733 8.17574 5.69818 7.94735 5.92424L7.94706 5.92395L7.93977 5.93231L7.89023 5.98916L7.88993 5.9889L7.88333 5.9977L4.11723 11.0192C3.78602 11.4608 3.7624 12.0562 4.04631 12.5198L4.04616 12.5199L4.05014 12.5257L4.11314 12.6185L4.11301 12.6186L4.11724 12.6242L7.88333 17.6457C8.10168 17.9368 8.5147 17.9958 8.80583 17.7775C9.07061 17.5789 9.14328 17.2195 8.99022 16.937Z",
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-width": "0.3"
    }, null, -1)
  ]))]))
}
export default { render: render }